export const getMinValue = (data) => {
    const maxItemsArr = data.map(({ data: innerData }) => innerData.reduce((previous, current) => (current[1] < previous ? current[1] : previous), 0));
    return Math.min.apply(null, maxItemsArr);
};
//# sourceMappingURL=getMinValue.js.map